// sync
import state from './state'


export default {
  updateUserInfo(state, data) {
    state.user_info = {
      ...state.user_info,
      ...JSON.parse(JSON.stringify(data))
    }
  },
  clearUserInfo(state, data) {
    state.user_info = {
      ...state.user_info
    }
  },
  alert(state, data) {
    state.alert = data;
  },
  loading(state, data) {
    state.loading = data;
  }
}


// WEBPACK FOOTER //
// ./app/store/mutations.js